/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace GeniuzPOS.Points {

    @Serenity.Decorators.registerClass()
    export class PrPointCampaignDialog extends Common.GridEditorDialog<PrPointCampaignRow> {
        protected getFormKey() { return PrPointCampaignForm.formKey; }
        protected getLocalTextPrefix() { return PrPointCampaignRow.localTextPrefix; }

        protected form: PrPointCampaignForm;

        constructor() {
            super();

            this.form = new PrPointCampaignForm(this.idPrefix);

        }
    }
}
